module.exports = __webpack_public_path__ + "img/ivory.8d48c6ac.jpg";